module.exports = __webpack_public_path__ + "static/social-f4febba44d08dab4a48f48b2e73bc3cc.png";